import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { SubmitButtonModule } from '@app/shared/ui/components/buttons/submit-button/module/submit-button.module';
import { TaskReminderComponent } from '@app/pages/tasks/components/reminders/task-reminder/task-reminder.component';
import { TaskReminderFormComponent } from '@app/pages/tasks/components/reminders/task-reminder-form/task-reminder-form.component';
import { DatepickerInputModule } from '@app/shared/ui/components/inputs/datepicker/module/datepicker-input.module';
import { TimePickerModule } from '@app/shared/ui/components/inputs/time-picker/module/time-picker.module';
import { AutocompleteModule } from '@app/shared/ui/components/inputs/autocomplete/module/autocomplete.module';
import { TextareaInputModule } from '@app/shared/ui/components/inputs/textarea-input/module/textarea-input.module';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { DropdownMenuInputModule } from '@app/shared/ui/components/inputs/dropdown-menu/module/dropdown-menu-input.module';
import { FreeTextInputModule } from '@app/shared/ui/components/inputs/free-text/module/free-text-input.module';

@NgModule({
	declarations: [TaskReminderComponent, TaskReminderFormComponent],
	exports: [TaskReminderComponent, TaskReminderFormComponent],
	imports: [
		CommonModule,
		MatIconModule,
		SubmitButtonModule,
		DatepickerInputModule,
		TimePickerModule,
		AutocompleteModule,
		TextareaInputModule,
		ReactiveFormsModule,
		TranslatePipe,
		DropdownMenuInputModule,
		FreeTextInputModule
	]
})
export class RemindersModule {}
